<template><div class="booking-toolbar">
    <div class="booking-toolbar__wrap">
        <template v-if="props.ForOverview">

            <div class="booking-toolbar__total-cabins">

                <div class="booking-toolbar__selected-cabins">
                    <RoomSelector 
                        v-for="({id, Cabin, CabinSet}) in cstore.getCabins" :key="id" 
                        :Cabin="Cabin" :CabinSet="CabinSet" For="toolbar"
                    />
                </div>

            </div>
            <button  class="btn booking-toolbar__button" :disabled="!cstore.getCabins.length" @click="fill_click">
                Забронировать
            </button>

        </template>
        <template v-else-if="props.ForFill">

            <div class="booking-toolbar__total-price">
                <div class="booking-toolbar__text">Итого: </div>

                <div>
                    <PriceCurrencyV 
                    class="booking-toolbar__price"
                    v-if="bookPrecalc" 
                                :price="bookPrecalcSum"
                                :sum="true" />

                </div>
            </div>
            <div class="booking-toolbar__wrapButs">
                <button  class="btn booking-toolbar__linkbut" @click="cruise_click">
                    <span class="desktop">Выбрать другие каюты</span><span class="mobile">Назад</span>
                </button>


                <button  class="btn booking-toolbar__button" :disabled="errors.length>0" @click="preview_click">
                    <span class="desktop">Проверить и забронировать</span><span class="mobile">Забронировать</span>
                </button>
            </div>


        </template>
        <template v-else-if="props.ForBook">

            <div class="booking-toolbar__total-price">
                <div class="booking-toolbar__text">Итого: </div>

                <div>
                    <PriceCurrencyV 
                    class="booking-toolbar__price"
                    v-if="bookPrecalc" 
                    :price="bookPrecalcSum"
                    :sum="true" />
                </div>
            </div>
            
            <div class="booking-toolbar__wrapButs">
                <button  class="btn booking-toolbar__linkbut" @click="fill_click">
                    <span class="desktop">Вернуться</span><span class="mobile">Назад</span>
                </button>


                <button  class="btn booking-toolbar__button" :disabled="!props.maybook.may" @click="book_click">
                    Забронировать
                </button>
            </div>


        </template>

    </div>
</div></template>

<style lang="scss" src="./BookCabins.scss"></style>

<script setup>
import {computed, ref, unref, onMounted} from 'vue'
import { useRouter, useRoute } from 'vue-router/composables'
import useCruiseStore from '@/cstore.js'
import useCabinsStore from '@/bookCabins.js'
import useTouristStore from '@/tourist/tourist-store.js'
import RoomSelector from '@/comp/FaseList/RoomSelector.vue'
import {book_sumV} from '@/comp/useOrder.js'
import PriceCurrencyV from '@/comp/CruiseHead/PriceCurrencyV.vue'

const cstore = useCruiseStore()
const bookCabins = useCabinsStore()
const tstore = useTouristStore()
const router = useRouter()

const props = defineProps({
    ForOverview: {type: Boolean, default: false,},
    ForFill: {type: Boolean, default: false,},
    ForBook: {type: Boolean, default: false,},
    maybook: {type: Object,},
})
const emits = defineEmits([ 'dobook' ])

const bookPrecalc = bookCabins.getBookPrecalc()

const bookPrecalcSum = computed(() => {
    let ret = null
    let old = unref( bookPrecalc )
    if (old) {
        let {cabs, calc} = old
        if (calc.ok && calc.acc && cabs) {
            ret = book_sumV(cabs)
        }
    }
    return ret
})

onMounted(() => {
    bookCabins.initBookPrecalc({cstore, tstore, bookCabins })      
})

const pre_price = computed( () => {
    let ret = { v: [ null, 1 ] }
    if (props.maybook && props.maybook.calc_prices) {
//..console.log(props.maybook)
        ret = book_sumV( props.maybook.calc_prices )
    } 
/*    
    else {
        let sum = unref(bookPrecalcSum)
        if (sum) {
            ret = sum
        }
    } 
*/    
    return ret
} )


const mest = ({adult, child, infant}) => {
    return `${adult+child+infant} гостя`
}

const cruise_click = () => {
    const {cruiseIdFull} = bookCabins.bookBox
    const query={
        cruiseIdFull,
        anchor: 'Cabins',
    }
    router.push({name: 'Cruise', query })
}


const book_click = () => {
    emits('book')
} 

const fill_click = () => {
    const {cruiseIdFull} = unref(bookCabins.bookBox)
    const anchor = 'guests'
    const query={
        cruiseIdFull, anchor,
    }
    router.push({name: 'CruiseFill', query })
}
const preview_click = () => {
    const {cruiseIdFull} = unref(bookCabins.bookBox)
    const anchor = 'guests'
    const query={
        cruiseIdFull, anchor,
    }
    router.push({name: 'CruiseBook', query })
}

const errors = computed( () => {
    const ret = []
//    const ret = useCruiseOrderCheck( tstore.pers, cstore.getCabins, tstore.customer )
    return ret
} )


</script>
